/* ln-interactions.js — Lilla Napoli micro-interactions (Fas 1)
   1) Tap haptics: a short navigator.vibrate() tick on press of any
      interactive control, so a touch feels physical (Android/Chrome;
      no-ops where unsupported, e.g. iOS Safari). The visual press
      feedback lives in CSS (:active scales in ln-figma.css).
   2) Editorial parallax: gently translates image-with-text media as
      it scrolls through the viewport (desktop only, rAF-throttled).
   Both are progressive enhancement. Reversible: delete this file +
   its <script> tag in layout/theme.liquid. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Tap haptics ----------
     Android/Chrome: navigator.vibrate() (a real 6ms tick).
     iOS Safari: no Vibration API exists, so vibrate() is a silent no-op.
     Fallback for iOS 17.4+ — toggling a hidden <input switch> inside a
     user gesture makes iOS play its native switch haptic. Both are
     best-effort progressive enhancement and no-op where unsupported.
     .card-wrapper is included (not just its <a>) so a tap anywhere on a
     product card registers, even when the press lands on the image. */
  var HAPTIC_SEL =
    '.header__menu-item, .header__icon, .card-wrapper, .card-wrapper a, ' +
    '.button, .ln-sort__summary, .ln-sort__option, .menu-drawer__menu-item, ' +
    'button[type="submit"], .rte a';

  var canVibrate = 'vibrate' in navigator;

  // Lazily-built hidden switch used for the iOS haptic trick.
  var iosSwitch = null;
  function iosHapticTick() {
    try {
      if (!iosSwitch) {
        var label = document.createElement('label');
        label.setAttribute('aria-hidden', 'true');
        label.style.cssText =
          'position:absolute;top:0;left:0;width:1px;height:1px;' +
          'opacity:0;pointer-events:none;overflow:hidden;';
        iosSwitch = document.createElement('input');
        iosSwitch.type = 'checkbox';
        iosSwitch.setAttribute('switch', ''); // Safari-only; ignored elsewhere
        iosSwitch.tabIndex = -1;
        label.appendChild(iosSwitch);
        (document.body || document.documentElement).appendChild(label);
      }
      iosSwitch.checked = !iosSwitch.checked;
    } catch (err) {}
  }

  function triggerHaptic() {
    if (canVibrate) {
      try { navigator.vibrate(6); } catch (err) {}
    }
    iosHapticTick();
  }

  // pointerdown fires at press time (before release) → feels instant.
  document.addEventListener(
    'pointerdown',
    function (e) {
      var t = e.target;
      if (t && t.closest && t.closest(HAPTIC_SEL)) {
        triggerHaptic();
      }
    },
    { passive: true }
  );

  /* ---------- 1b. Mobile drawer close button ----------
     The full-screen drawer covers the header, hiding Dawn's hamburger→X
     toggle. Our in-drawer X closes via the exact same path a user tap
     on the summary would — so Dawn runs its own close/unlock logic. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.ln-drawer-close');
    if (!btn) return;
    var summary = document.querySelector(
      '#Details-menu-drawer-container > summary'
    );
    if (summary) summary.click();
  });

  /* ---------- 2. Editorial parallax ---------- */
  var desktop = window.matchMedia('(min-width: 750px)').matches;
  if (reduce || !desktop) return;

  var items = [];
  function collect() {
    var media = document.querySelectorAll('.image-with-text__media');
    media.forEach(function (m) {
      var img = m.querySelector('img');
      if (img) items.push({ frame: m, img: img });
    });
  }

  var AMP = 34; // max px of travel each way
  var ticking = false;

  function update() {
    ticking = false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var r = it.frame.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) continue; // off-screen, skip
      // progress: -1 (entering bottom) → 0 (centred) → +1 (leaving top)
      var center = r.top + r.height / 2;
      var progress = (center - vh / 2) / (vh / 2 + r.height / 2);
      if (progress > 1) progress = 1;
      if (progress < -1) progress = -1;
      var y = -progress * AMP;
      it.img.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
    }
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  function init() {
    collect();
    if (!items.length) return;
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================
   PDP restructure (Fas 1) — bring the product info column in line
   with the Figma: quantity + add-to-cart on one row, and the stock
   status lifted out of the custom price block to sit just above that
   row. Runs on the product page only. Reversible with this file.
   ============================================================ */
(function () {
  function start() {
    var info = document.querySelector('.product__info-container');
    if (!info) return;

    // (a) Quantity + add-to-cart share one row
    var qtyBlock = info.querySelector('.product-form__quantity');
    var buyBlock = info.querySelector('.product-buybutton');
    if (qtyBlock && buyBlock && !info.querySelector('.ln-buy-row')) {
      var row = document.createElement('div');
      row.className = 'ln-buy-row';
      qtyBlock.parentNode.insertBefore(row, qtyBlock);
      row.appendChild(qtyBlock);
      row.appendChild(buyBlock);
    }

    // (b) Stock status → above the buy row. The custom price block
    //     re-renders on every variant change, re-inserting availability
    //     nodes, so keep them synced with a MutationObserver instead of
    //     moving once. Idempotent: settles because after the move there
    //     are no availability nodes left inside .price-review.
    function syncStock() {
      var priceReview = info.querySelector('.price-review');
      if (!priceReview) return;
      var avails = priceReview.querySelectorAll('.product-variant-availability');
      if (!avails.length) return;
      var holder = info.querySelector('.ln-stock-status');
      if (!holder) {
        holder = document.createElement('div');
        holder.className = 'ln-stock-status';
        var anchor =
          info.querySelector('.ln-buy-row') ||
          info.querySelector('.product-form__quantity');
        if (anchor) anchor.parentNode.insertBefore(holder, anchor);
        else info.appendChild(holder);
      }
      holder.innerHTML = '';
      Array.prototype.forEach.call(avails, function (a) {
        holder.appendChild(a);
      });
    }
    syncStock();

    // (c) Wrap the product description in a "Description" accordion — first
    //     in the group, open by default — so it matches the collapsible rows.
    var desc = info.querySelector('.product__description');
    var firstAcc = info.querySelector('.product__accordion');
    if (desc && firstAcc && !info.querySelector('.ln-desc-accordion')) {
      var wrap = document.createElement('div');
      wrap.className = 'product__accordion accordion ln-desc-accordion';
      var det = document.createElement('details');
      det.open = true;
      var sum = document.createElement('summary');
      sum.innerHTML =
        '<div class="summary__title"><h2 class="accordion__title">Description</h2></div>';
      var content = document.createElement('div');
      content.className = 'accordion__content rte';
      det.appendChild(sum);
      det.appendChild(content);
      wrap.appendChild(det);
      firstAcc.parentNode.insertBefore(wrap, firstAcc);
      content.appendChild(desc);
    }

    new MutationObserver(syncStock).observe(info, {
      childList: true,
      subtree: true,
    });

    // (d) Staggered entrance for the info-column blocks. Applied to the
    //     FINAL structure (after the moves above) and triggered when the
    //     column scrolls into view, so all blocks cascade in together.
    //     No-op under reduced motion / without IntersectionObserver.
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce && 'IntersectionObserver' in window) {
      var kids = Array.prototype.filter.call(info.children, function (el) {
        var tag = el.tagName;
        if (tag === 'SCRIPT' || tag === 'NOSCRIPT' || tag === 'STYLE') return false;
        return el.getClientRects().length > 0; // skip empty/zero-size blocks
      });
      kids.forEach(function (el, i) {
        el.classList.add('ln-pdp-reveal');
        el.style.setProperty('--ln-i', i > 7 ? 7 : i);
      });
      var io = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              kids.forEach(function (el) { el.classList.add('ln-in'); });
              obs.disconnect();
            }
          });
        },
        { threshold: 0.05 }
      );
      io.observe(info);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ============================================================
   Mobile drawer — bulletproof iOS scroll lock (Fas 1).
   Dawn only puts overflow:hidden on <body>, which iOS Safari ignores for
   touch: the page behind the open drawer still scrolls and rubber-band
   bounces, which is most of the drawer's iOS flakiness. The reliable fix is
   to pin the body with position:fixed while the drawer is open, remembering
   and restoring the scroll position on close. We drive it off the drawer
   <details> open attribute, so every open/close path (hamburger, our X,
   Escape, backdrop) is covered.
   (The old #MainContent padding sync was removed — the header is now
   position:sticky and sits in normal flow, so no offset is needed.)
   ============================================================ */
(function () {
  var details = document.querySelector('#Details-menu-drawer-container');
  if (!details) return;

  var savedY = 0;
  var locked = false;

  function lock() {
    if (locked) return;
    savedY = window.scrollY || window.pageYOffset || 0;
    var b = document.body.style;
    b.position = 'fixed';
    b.top = -savedY + 'px';
    b.left = '0';
    b.right = '0';
    b.width = '100%';
    locked = true;
  }

  function unlock() {
    if (!locked) return;
    var b = document.body.style;
    b.position = '';
    b.top = '';
    b.left = '';
    b.right = '';
    b.width = '';
    locked = false;
    window.scrollTo(0, savedY);
  }

  new MutationObserver(function () {
    if (details.hasAttribute('open')) lock();
    else unlock();
  }).observe(details, { attributes: true, attributeFilter: ['open'] });
})();

/* ============================================================
   Mobile: search icon beside the hamburger (Fas 1).
   The search modal is nested inside .header__icons (right side), so CSS
   alone can't move it into the left grid area. On mobile widths we move
   the whole <details-modal> node to be a direct child of .header, right
   after <header-drawer>, and tag it so ln-figma.css can slot it left.
   Restored to its original spot on desktop. Moving a node keeps its
   listeners, so the search modal keeps working.
   ============================================================ */
(function () {
  var header = document.querySelector('.header.header--has-menu');
  if (!header) return;
  var search = header.querySelector('.header__search');
  var drawer = header.querySelector('header-drawer');
  if (!search || !drawer) return;

  var home = search.parentNode; // original parent (.header__icons)
  var homeNext = search.nextSibling; // original position anchor
  var mq = window.matchMedia('(max-width: 749px)');

  function apply() {
    if (mq.matches) {
      if (!search.classList.contains('ln-search--left')) {
        header.insertBefore(search, drawer.nextSibling);
        search.classList.add('ln-search--left');
      }
    } else if (search.classList.contains('ln-search--left')) {
      home.insertBefore(search, homeNext);
      search.classList.remove('ln-search--left');
    }
  }

  apply();
  if (mq.addEventListener) mq.addEventListener('change', apply);
  else if (mq.addListener) mq.addListener(apply);
})();

/* ============================================================
   Product image lightbox — force-load its images on open (Fas 1).
   The lightbox <img>s are loading="lazy" and live in a display:none container
   until the modal opens, so native lazy-loading never fires and the modal
   showed blank/white. When it opens, make them eager and re-trigger the fetch.
   Pairs with the ln-figma.css rules that lay them out as a scrollable gallery.
   ============================================================ */
(function () {
  var modals = document.querySelectorAll('.product-media-modal');
  if (!modals.length) return;
  modals.forEach(function (modal) {
    function loadImgs() {
      modal.querySelectorAll('img').forEach(function (img) {
        img.loading = 'eager';
        if (!img.complete || img.naturalWidth === 0) {
          var src = img.getAttribute('src');
          if (src) img.setAttribute('src', src);
        }
      });
    }
    new MutationObserver(function () {
      if (modal.hasAttribute('open')) loadImgs();
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
  });
})();

/* ============================================================
   Hide ONLY the Pandectes floating cookie button (Fas 1).
   The button (<button class="widget ...">) lives inside pandectes-cmp's shadow
   DOM, alongside the consent banner. Hiding the host would kill the banner too
   (GDPR), so instead we inject a <style> INTO the shadow root that hides just
   the .widget button — the banner and consent logic stay intact. The button
   has no inline !important, so shadow CSS wins cleanly (no per-element war).
   Re-injected if the app rebuilds the shadow content.
   ============================================================ */
(function () {
  var HIDE = 'button.widget{display:none !important;}';
  var watched = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  function inject(root) {
    if (root && !root.getElementById('ln-hide-cookie-btn')) {
      var st = document.createElement('style');
      st.id = 'ln-hide-cookie-btn';
      st.textContent = HIDE;
      root.appendChild(st);
    }
  }
  function handle(cmp) {
    var root = cmp.shadowRoot;
    if (!root) return;
    inject(root);
    if (watched && !watched.has(root)) {
      watched.add(root);
      new MutationObserver(function () { inject(root); }).observe(root, { childList: true });
    }
  }
  function scan() { document.querySelectorAll('pandectes-cmp').forEach(handle); }
  scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  [500, 1500, 3000].forEach(function (t) { setTimeout(scan, t); });
})();
